import { Pipe, PipeTransform } from '@angular/core';
import { TopicUtils, TopicField, SimpleTopic } from '@app/origami-api/utils/topic-utils';

@Pipe({
  standalone: true,
  name: 'tiGetTopicFieldValue',
})
export class GetTopicFieldValuePipe implements PipeTransform {
  transform(topicFields: SimpleTopic | TopicField[], fieldName: string): number {
    return TopicUtils.getTopicFieldValue(topicFields, fieldName);
  }
}
